(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hb-suburb-search"] && !Shopify.designMode) return;
  try {
    function setupSuburbSearch() {
    const input = document.getElementById('HbSuburbSearch');
    if (!input || input.dataset.ready) return;
    input.dataset.ready = 'true';
    const groups = [...document.querySelectorAll('.hb-locality-group')];
    const status = document.getElementById('HbSuburbSearchStatus');
    const normalize = text => text.normalize('NFKD').toLowerCase().replace(/[^a-z0-9]/g, '');
    input.addEventListener('input', () => {
      const query = normalize(input.value);
      let count = 0;
      groups.forEach(group => {
        let visible = 0;
        group.querySelectorAll('li[data-search]').forEach(row => {
          const matches = normalize(row.dataset.search).includes(query);
          row.hidden = !matches;
          if (matches) visible++;
        });
        group.hidden = visible === 0;
        count += visible;
      });
      status.textContent = count ? `${count} matching ${count === 1 ? 'locality' : 'localities'}. Check your delivery address and date before ordering.` : 'No matching locality. Contact us to check your delivery address.';
    });
  }
  setupSuburbSearch();
  document.addEventListener('shopify:section:load', setupSuburbSearch);
  } catch(e) { console.error(e); }
})();

})();
